import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ErrorService } from '../../../services/error/error.service';
import { FileService } from '../../../services/file.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { DocumentResponse } from '../../jurisdiction.domain';
import { FacilitiesFormService } from '../facilities-form.service';
import { EnvironmentService } from '../../../services/environment.service';
import { JurisdictionService } from '../../jurisdiction.service';
import { FormTypesData } from '../../../domains/common.domain';
import { SectionIdentifier } from 'src/app/+shared/components/review-section/review-section.domain';

@Component({
  selector: 'app-old-meter-data',
  styleUrls: ['./old-meter-data.component.scss'],
  templateUrl: 'old-meter-data.component.html',
})
export class OldMeterDataComponent implements OnInit, OnChanges {
  @Input() isReadOnly: boolean = false;
  @Input() currentFormType: FormTypesData;
  @Input() isDetailsView: boolean = false;

  meterFG: FormGroup;
  fileName: string;
  formSubscription: Subscription;
  infoBubblesData: {
    [key: string]: boolean;
  };
  showData: boolean = true;

  @Input() oldMeterData: any = null;

  isMeterNumberRequired = this.environmentService.isMeterNumberRequiredOnFacilitiesData;
  applicationId: any;
  get oldMeterDataSectionIdentifier(): SectionIdentifier {
    if (this.currentFormType.key === 'heating') return SectionIdentifier.TechnicalData_OldMeterData_Heating;
    else if (this.currentFormType.key === 'water') return SectionIdentifier.TechnicalData_OldMeterData_Water;
    else if (this.currentFormType.key === 'power') return SectionIdentifier.TechnicalData_OldMeterData_Power;
    else if (this.currentFormType.key === 'gas') return SectionIdentifier.TechnicalData_OldMeterData_Gas;
    else return null;
  }

  constructor(
    private facilitiesFormService: FacilitiesFormService,
    private localStorageService: LocalStorageService,
    private fileService: FileService,
    private errorService: ErrorService,
    private environmentService: EnvironmentService,
    private jurisdictionService: JurisdictionService
  ) {}

  ngOnInit(): void {
    this.applicationId = this.localStorageService.getItem('application_id');
    this.infoBubblesData = this.environmentService.getInfoBubblesData('facilitiesData') || null;
    this.prepareForm();
    this.jurisdictionService.setMediaType(this.currentFormType.key).subscribe(isPower => {
      this.showData = isPower;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    var currentFormTypeUpdateOnChanges = this.isReadOnly ? changes?.currentFormType?.firstChange : !changes?.currentFormType?.firstChange;
    var oldMeterDataUpdateOnChanges = this.isReadOnly ? changes?.oldMeterData?.firstChange : !changes?.oldMeterData?.firstChange;
    if ((changes?.currentFormType && currentFormTypeUpdateOnChanges) || (changes?.oldMeterData && oldMeterDataUpdateOnChanges)) {
      this.prepareForm();
    }
  }

  prepareForm(): void {
    this.meterFG = new FormGroup({
      meterNumber: new FormControl(this.oldMeterData.replaced_meter_no || '', [
        ...(this.isMeterNumberRequired ? [Validators.required] : []),
      ]),
      ...(this.environmentService.showMeterReadingField && {
        meterReading: new FormControl(this.oldMeterData.replaced_meter_reading || ''),
      }),
      ...(this.environmentService.showMeterImageUpload && {
        meterImageId: new FormControl(this.oldMeterData.replaced_meter_image_id || ''),
        meterDocumentName: new FormControl(''),
      }),
    });
    this.fileName = '';

    this.facilitiesFormService.registerForComponentFormUpdate.next({
      component: 'oldMeterData',
      formData: this.meterFG,
    });

    this.formSubscription = this.meterFG.valueChanges.subscribe(() => {
      this.facilitiesFormService.registerForComponentFormUpdate.next({
        component: 'oldMeterData',
        formData: this.meterFG,
      });
    });
  }

  onImageUpload(event: any, uploader: any): void {
    const name = this.meterFG.value.meterDocumentName;
    this.fileService.uploadDocumentsForWorkflows(event, this.applicationId, 'other', name).subscribe(
      (response: DocumentResponse) => {
        this.fileName = event && event.currentFiles && event.currentFiles[0] && event.currentFiles[0].name;
        this.meterFG.controls.meterImageId.setValue(response.document[0].document_id);
        uploader.clear();
        this.errorService.throwErrorIfFailure(response, true);
      },
      error => {
        uploader.clear();
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  removeFile(): void {
    this.fileService.removeWorkflowDocument(this.meterFG.value.meterImageId).subscribe(
      response => {
        this.fileName = '';
        this.meterFG.controls.meterDocumentName.setValue('');
        this.meterFG.controls.meterImageId.setValue('');
        this.errorService.throwErrorIfFailure(response, true);
      },
      error => {
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  downloadDocument(): void {
    this.fileService.readWorkflowDocument(this.meterFG.value.meterImageId).subscribe((response: Blob) => {
      this.fileService.downloadDocument(response, this.meterFG.value.meterDocumentName);
    });
  }
}
